module.exports = __webpack_public_path__ + "img/guide_1.214a1c53.png";